/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { t } from '../TranslationProvider';
const integer2FullString = (dateNumber) => ('0' + dateNumber).slice(-2);

const bareDateTimeFormat = (inputDate, format, listView = false) => {
    const date = new Date(inputDate);
    const day = integer2FullString(date.getDate());
    const month = integer2FullString(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = integer2FullString(date.getHours());
    const minutes = integer2FullString(date.getMinutes());
    const seconds = integer2FullString(date.getSeconds());
    if (year === 1970 && listView) {
        return '';
    }
    if (year === 3000 && listView) {
        return t('not.available');
    }
    let bareDate = `${day}/${month}/${year} - ${hours}:${minutes}`;
    if (format === 'dd/mm/YY') bareDate = `${day}/${month}/${year}`;
    else if (format === 'YY-mm-dd') bareDate = `${year}-${month}-${day}`;
    else if (format === 'gmt') bareDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds} GMT`; //date return example: 01-12-2020 14:28:13 GMT

    return bareDate;
};

export { bareDateTimeFormat };
